export function formatProgramAddressString(address) {
  const { address1, cityName, stateCode, } = address
  let addressString = '';
  if (address1 && address1.length > 0){
    addressString += address1 + ', '
  }
  if (cityName && cityName.length > 0) {
    addressString += cityName + ', '
  } 
  if (stateCode && stateCode.length > 0) {
    addressString += stateCode + '.'
  }
  return addressString
}

export function formatProgramAddressForMap(address){
  const { address1, cityName, stateCode, } = address
  let addressString = '';
  if (address1 && address1.length > 0){
    addressString += address1 + ', '
  }
  if (cityName && cityName.length > 0) {
    addressString += cityName + ', '
  } 
  if (stateCode && stateCode.length > 0) {
    addressString += stateCode
  }
  return addressString
}

export function formatAddressUrlString (address) {
  let urlString = address.split(',')
  let commaMod = urlString.join('%2C')
  let finalString = commaMod.split(' ')
  return finalString.join('+')
}